/*
 * @Author: your name
 * @Date: 2020-12-21 08:44:35
 * @LastEditTime: 2021-02-02 11:37:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\Events.js
 */

export const Events = {
  CameraRotate: 'CamRotate',
  CameraFovChange: 'Fov',
  IndexChange: 'IndexChange',
  MainCameraChange: 'CamChange',

  SceneReady: 'SceneReady',
  CancelLoading: 'CancelLoading',

  MouseStart: 'MouseStart',
  MouseEnd: 'MouseEnd',

  BeforeWalkIn3D: 'BeforeWalkIn3D',
  AfterWalkIn3D: 'AfterWalkIn3D',
  BeforeToGod: 'BeforeToGod',
  To2D: 'To2D',
  To3D: 'To3d',
  ToPano: 'ToPano',
  BeforeWalkTo: 'BeforeWalkTo',
  AfterWalkTo: 'AfterWalkTo',
  VisitPano: 'VisitPano',
  Update: 'Update',

  HotpointOpen: 'HotpointOpen',
  HotpointClose: 'HotpointClose',

  HotpointAnimationPlay: 'HotpointPlay',
  HotpointAnimationStop: 'HotpointStop',

  MeasureOn: 'MeasureOn',
  MeasureClose: 'MeasureClose',

  ClickTag: 'ClickTag',
  Keyboard: 'Keyboard',

  EPSclickPoint: 'EPSclickPoint',
  EPSclickPointFail: 'EPSclickPointFail',

  GetMessageReady: 'GetMessageReady',

  SetWelcomeBtn: 'SetWelcomeBtn',

  AutoPlayStart: 'AutoPlayStart',
  AutoPlayPause: 'AutoPlayPause',

  SetSpeed: 'SetSpeed',
  SetSpeedList: 'SetSpeedList'
}
